import { Flex, Heading } from '@weareberyl/design-system'
import { Card, Row, Col } from 'antd'
import Map from './Map'
import Summary from './Summary'
import VehiclesInZone from './VehiclesInZone'
import { zoneIdToAssetTag } from '~/components/Job/utils'
import HeadTitle from '~/components/HeadTitle'
import AssetJobs from '~/components/Job/List/AssetJobs'
import ScheduledZoneSuspensions from './ScheduledZoneSuspensions'
import { ScheduledIcon } from './ScheduledIcon'

type ZoneProps = {
  id: string
  schemeId: string
}

const Zone = ({ id, schemeId }: ZoneProps) => (
  <>
    <HeadTitle pageTitle={`Bay ${id}`} />
    <Row gutter={16} className="fill-height">
      <Col xs={24} lg={12}>
        <Summary id={id} />
      </Col>
      <Col xs={24} lg={12}>
        <Card
          id="zone-map-card"
          bodyStyle={{ padding: 0 }}
          style={{ containerType: 'size' }}
        >
          <div className="minimap-wrapper">
            <Map id={id} />
          </div>
        </Card>
      </Col>
    </Row>
    <Row gutter={16} className="fill-height">
      <Col xs={24}>
        <Card id="vehicles-in-zone-card" title="Vehicles in Bay">
          <VehiclesInZone id={id} />
        </Card>
      </Col>
    </Row>
    <Row gutter={16} className="fill-height">
      <Col xs={24}>
        <Card
          id="scheduled-bay-suspensions-card"
          title={
            <Flex
              flexDirection="row"
              alignItems="center"
              style={{ gridGap: 8 }}
            >
              <ScheduledIcon />
              <Heading>Scheduled Bay Suspensions</Heading>
            </Flex>
          }
        >
          <ScheduledZoneSuspensions id={id} />
        </Card>
      </Col>
    </Row>
    <AssetJobs assetTag={zoneIdToAssetTag(id)} scheme={{ id: schemeId }} />
  </>
)

export default Zone
